import { selectOptionConvert } from '../../helpers/selectOptionConvert';
import { RiskToleranceBase } from '../Base/RiskTolerance';

export const TKARiskTolerance = selectOptionConvert(RiskToleranceBase);
